import React, { useEffect, useState } from "react";
import { FiFileText, FiImage, FiFile } from "react-icons/fi";
import { expensesService } from "services";

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)$/i;
const PDF_EXT = /\.pdf$/i;

export const isImageFile = (name) => IMAGE_EXT.test(name ?? "");
export const isPdfFile = (name) => PDF_EXT.test(name ?? "");

/**
 * Thumbnail de adjunto.
 *
 * Para imágenes: carga el blob via API y muestra un <img>.
 * Para otros: muestra un icono de tipo de archivo.
 *
 * Props:
 *   expenseId  – id del gasto (para la llamada a la API)
 *   attachment – objeto { url, name, size }
 *   size       – tamaño en px del cuadrado (default: 44)
 *   count      – nº total de adjuntos (muestra badge si > 1)
 *   className  – clases extra
 */
const MobileAttachmentThumb = ({
	expenseId,
	attachment,
	size = 44,
	count = 1,
	className = "",
}) => {
	const [blobUrl, setBlobUrl] = useState(null);
	const isImg = isImageFile(attachment?.name);

	useEffect(() => {
		if (!isImg || !expenseId || !attachment?.url) return;

		let objectUrl = null;
		let cancelled = false;

		expensesService
			.getAttachment(expenseId, attachment.url)
			.then((blob) => {
				if (cancelled) return;
				objectUrl = window.URL.createObjectURL(blob);
				setBlobUrl(objectUrl);
			})
			.catch(() => {});

		return () => {
			cancelled = true;
			if (objectUrl) window.URL.revokeObjectURL(objectUrl);
		};
	}, [expenseId, attachment?.url, isImg]);

	const style = { width: size, height: size, fontSize: size * 0.38 };

	const badge =
		count > 1 ? (
			<span className="matt-thumb__badge">{count}</span>
		) : null;

	if (isImg && blobUrl) {
		return (
			<span className={`matt-thumb matt-thumb--img ${className}`} style={style}>
				<img
					className="matt-thumb__img"
					src={blobUrl}
					alt={attachment.name}
				/>
				{badge}
			</span>
		);
	}

	const Icon = isImg ? FiImage : isPdfFile(attachment?.name) ? FiFile : FiFileText;

	return (
		<span
			className={`matt-thumb matt-thumb--file ${className}`}
			style={style}
			title={attachment?.name}
		>
			<Icon size={size * 0.42} />
			{badge}
		</span>
	);
};

export default MobileAttachmentThumb;
